<div class="new-customer-dialog crm-dialog" [ngClass]="{'edit-mode': isEditMode}">
  <h2 mat-dialog-title>
    <mat-icon>{{ dialogIcon }}</mat-icon>
    {{ dialogTitle }}
  </h2>

  <mat-dialog-content>
    <!-- Típus választó -->
    <div class="type-selector">
      <mat-slide-toggle
        [(ngModel)]="isCompany"
        (ngModelChange)="onTypeChange()"
        [disabled]="isTypeSwitchDisabled"
        color="primary">
        <span class="toggle-label">
          <mat-icon>{{ isCompany ? 'business' : 'person' }}</mat-icon>
          {{ isCompany ? 'Cég' : 'Magánszemély' }}
        </span>
      </mat-slide-toggle>
    </div>

    <!-- Magánszemély form -->
    @if (!isCompany) {
      <div class="individual-form">
        <mat-card>
          <mat-card-header class="individual-header">
            <mat-card-title>
              <mat-icon>person</mat-icon>
              Magánszemély adatok
            </mat-card-title>
            <div class="header-actions">
              @if (data.showAnonymousInsuredCheckbox) {
                <mat-checkbox
                  [(ngModel)]="isAnonymousInsured"
                  (ngModelChange)="onAnonymousInsuredChange()"
                  name="isAnonymousInsured"
                  [disabled]="isSubmitting"
                  color="accent"
                  class="anonymous-checkbox-header">
                  Név nélküli biztosított hozzáadása
                </mat-checkbox>
              }
            </div>
          </mat-card-header>
          <mat-card-content>
            <div class="form-row">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Teljes név</mat-label>
                <input matInput
                  [(ngModel)]="individualData.fullName"
                  name="fullName"
                  required
                  placeholder="pl. Nagy Péter"
                  [disabled]="isSubmitting || isAnonymousInsured">
                <mat-icon matSuffix>person</mat-icon>
              </mat-form-field>
            </div>
            @if (!isAnonymousInsured) {
              <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Cím</mat-label>
                  <input matInput
                    [(ngModel)]="individualData.address"
                    name="address"
                    placeholder="pl. 1234 Budapest, Példa utca 12."
                    [disabled]="isSubmitting">
                  <mat-icon matSuffix>location_on</mat-icon>
                </mat-form-field>
              </div>
            }
            <div class="form-row">
              <mat-form-field appearance="outline" [class]="isAnonymousInsured ? 'full-width' : 'half-width'">
                <mat-label>Születési dátum</mat-label>
                <input matInput
                  [(ngModel)]="birthDateString"
                  (ngModelChange)="onBirthDateStringChange()"
                  name="birthDate"
                  placeholder="yyyy.mm.dd"
                  pattern="[0-9]{4}\.[0-9]{2}\.[0-9]{2}"
                  title="Kérem a dátumot yyyy.mm.dd formátumban adja meg"
                  [class.error-field]="!isValidBirthDateFormat(birthDateString)"
                  required
                  [disabled]="isSubmitting">
                <mat-icon matSuffix>event</mat-icon>
                @if (isValidBirthDateFormat(birthDateString)) {
                  <mat-hint>yyyy.mm.dd formátum</mat-hint>
                }
                @if (!isValidBirthDateFormat(birthDateString)) {
                  <mat-error>
                    @if (!birthDateString || birthDateString.trim() === '') {
                      <span>Születési dátum kötelező mező</span>
                    }
                    @if (birthDateString && birthDateString.trim() !== '' && !isValidBirthDateFormat(birthDateString)) {
                      <span>Érvénytelen dátum formátum. Használja: yyyy.mm.dd</span>
                    }
                  </mat-error>
                }
              </mat-form-field>
              @if (!isAnonymousInsured) {
                <mat-form-field appearance="outline" class="half-width">
                  <mat-label>Adószám</mat-label>
                  <input matInput
                    [(ngModel)]="individualData.taxNumber"
                    name="taxNumber"
                    placeholder="pl. 12345678-1-23"
                    [disabled]="isSubmitting">
                  <mat-icon matSuffix>receipt</mat-icon>
                </mat-form-field>
              }
            </div>
            @if (!isAnonymousInsured) {
              <div class="form-row">
                <mat-form-field appearance="outline" class="half-width">
                  <mat-label>Születési hely</mat-label>
                  <input matInput
                    [(ngModel)]="individualData.birthPlace"
                    name="birthPlace"
                    placeholder="pl. Budapest"
                    [disabled]="isSubmitting">
                  <mat-icon matSuffix>place</mat-icon>
                </mat-form-field>
                <mat-form-field appearance="outline" class="half-width">
                  <mat-label>Anyja neve</mat-label>
                  <input matInput
                    [(ngModel)]="individualData.motherName"
                    name="motherName"
                    placeholder="pl. Kiss Mária"
                    [disabled]="isSubmitting">
                  <mat-icon matSuffix>woman</mat-icon>
                </mat-form-field>
              </div>
            }
            <!-- Cég kiválasztása -->
            @if (!isAnonymousInsured) {
              <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Kapcsolódó cég (opcionális)</mat-label>
                  <input matInput
                    [matAutocomplete]="companyAutoComplete"
                    [(ngModel)]="selectedCompany"
                    name="companySearch"
                    (ngModelChange)="onCompanyInputChange($event)"
                    [disabled]="isCompanySelectionDisabled"
                    placeholder="Kezdje el gépelni a cég nevét...">
                  <mat-autocomplete #companyAutoComplete="matAutocomplete"
                    [displayWith]="displayCompanyName"
                    (optionSelected)="onCompanySelected($event)">
                    <mat-option [value]="null">
                      <em>Nincs cég kiválasztva</em>
                    </mat-option>
                    @for (company of filteredCompanies; track company) {
                      <mat-option [value]="company">
                        {{ company.displayText }}
                      </mat-option>
                    }
                  </mat-autocomplete>
                  <mat-icon matSuffix>business</mat-icon>
                  @if (loadingCompanies) {
                    <mat-hint>Cégek betöltése...</mat-hint>
                  }
                  @if (!loadingCompanies && availableCompanies.length === 0) {
                    <mat-hint>Nincsenek elérhető cégek</mat-hint>
                  }
                  @if (data.disableCompanySelection && selectedCompany) {
                    <mat-hint>Előre kiválasztott cég az illusztráció alapján</mat-hint>
                  }
                </mat-form-field>
              </div>
            }
            <!-- Meglévő ügyfél checkbox -->
            @if (!isAnonymousInsured) {
              <div class="checkbox-section">
                <mat-checkbox [(ngModel)]="individualData.isExistingCustomer"
                  name="isExistingIndividual"
                  [disabled]="data.showAnonymousInsuredCheckbox || isSubmitting || isEditMode"
                  color="primary">
                  Meglévő ügyfél
                </mat-checkbox>
              </div>
            }
          </mat-card-content>
        </mat-card>
      </div>
    }

    <!-- Cég form -->
    @if (isCompany) {
      <div class="company-form">
        <mat-card>
          <mat-card-header>
            <mat-card-title>
              <mat-icon>business</mat-icon>
              Cég adatok
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="form-row">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Cég neve</mat-label>
                <input matInput
                  [(ngModel)]="companyData.name"
                  name="companyName"
                  required
                  placeholder="pl. Nagy és Társai Kft."
                  [disabled]="isSubmitting">
                <mat-icon matSuffix>business</mat-icon>
              </mat-form-field>
            </div>
            <div class="form-row">
              <mat-form-field appearance="outline" class="half-width">
                <mat-label>Adószám</mat-label>
                <input matInput
                  [(ngModel)]="companyData.taxNumber"
                  name="companyTaxNumber"
                  placeholder="pl. 12345678-2-41"
                  [disabled]="isSubmitting">
                <mat-icon matSuffix>receipt</mat-icon>
              </mat-form-field>
              <mat-form-field appearance="outline" class="half-width">
                <mat-label>Cégjegyzékszám</mat-label>
                <input matInput
                  [(ngModel)]="companyData.registrationNumber"
                  name="registrationNumber"
                  placeholder="pl. 01-09-123456"
                  [disabled]="isSubmitting">
                <mat-icon matSuffix>badge</mat-icon>
              </mat-form-field>
            </div>
            <div class="form-row">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Cím</mat-label>
                <input matInput
                  [(ngModel)]="companyData.address"
                  name="companyAddress"
                  placeholder="pl. 1234 Budapest, Vállalati út 1."
                  [disabled]="isSubmitting">
                <mat-icon matSuffix>location_on</mat-icon>
              </mat-form-field>
            </div>
            <div class="form-row">
              <mat-form-field appearance="outline" class="half-width">
                <mat-label>Főtevékenység</mat-label>
                <input matInput
                  [(ngModel)]="companyData.mainActivity"
                  name="mainActivity"
                  placeholder="pl. Kereskedelmi tevékenység"
                  [disabled]="isSubmitting">
                <mat-icon matSuffix>work</mat-icon>
              </mat-form-field>
              <mat-form-field appearance="outline" class="half-width">
                <mat-label>Megye</mat-label>
                <mat-select [(ngModel)]="companyData.county"
                  name="county"
                  [disabled]="isSubmitting">
                  @for (county of counties; track county) {
                    <mat-option [value]="county">
                      {{ county }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="form-row">
              <mat-form-field appearance="outline" class="half-width">
                <mat-label>Nettó árbevétel</mat-label>
                <input matInput
                  type="number"
                  [(ngModel)]="companyData.netRevenue"
                  name="netRevenue"
                  placeholder="pl. 150000000"
                  [disabled]="isSubmitting">
                <mat-icon matSuffix>attach_money</mat-icon>
                <mat-hint>M Ft-ban megadva</mat-hint>
              </mat-form-field>
              <mat-form-field appearance="outline" class="half-width">
                <mat-label>Alkalmazottak száma</mat-label>
                <input matInput
                  type="number"
                  [(ngModel)]="companyData.employeeCount"
                  name="employeeCount"
                  placeholder="pl. 25"
                  min="0"
                  [disabled]="isSubmitting">
                <mat-icon matSuffix>people</mat-icon>
              </mat-form-field>
            </div>
            <!-- Meglévő ügyfél checkbox -->
            <div class="checkbox-section">
              <mat-checkbox [(ngModel)]="companyData.isExistingCustomer"
                name="isExistingCompany"
                [disabled]="data.showAnonymousInsuredCheckbox || isSubmitting || isEditMode"
                color="primary">
                Meglévő ügyfél
              </mat-checkbox>
            </div>
          </mat-card-content>
        </mat-card>
        <!-- Magánszemélyek hozzáadása a céghez -->
        @if (!isEditMode) {
          <mat-card class="individuals-card">
            <mat-card-header>
              <mat-card-title>
                <mat-icon>people</mat-icon>
                Tisztségviselők / Kapcsolattartók
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <!-- Meglévő magánszemélyek -->
              @if (companyData.individuals.length > 0) {
                <div class="existing-individuals">
                  @for (individual of companyData.individuals; track individual; let i = $index) {
                    <div
                      class="individual-item">
                      <div class="individual-info">
                        <strong>{{ individual.fullName }}</strong>
                        @if (individual.address) {
                          <span>{{ individual.address }}</span>
                        }
                        @if (individual.taxNumber) {
                          <span class="tax-number">Adószám: {{ individual.taxNumber }}</span>
                        }
                      </div>
                      <button mat-icon-button
                        color="warn"
                        (click)="removeIndividualFromCompany(i)"
                        [disabled]="isSubmitting"
                        matTooltip="Személy eltávolítása">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  }
                </div>
              }
              <!-- Új személy hozzáadása gomb (ha nincs aktív form) -->
              @if (!showIndividualForm) {
                <div class="add-individual-button-section">
                  <button mat-raised-button
                    color="accent"
                    (click)="showAddIndividualForm()"
                    [disabled]="isSubmitting">
                    <mat-icon>person_add</mat-icon>
                    Személy hozzáadása
                  </button>
                </div>
              }
              <!-- Új magánszemély hozzáadása form (csak ha aktív) -->
              @if (showIndividualForm) {
                <div class="add-individual-section">
                  <h4>Új személy hozzáadása</h4>
                  <div class="form-row">
                    <mat-form-field appearance="outline" class="half-width">
                      <mat-label>Teljes név *</mat-label>
                      <input matInput
                        [(ngModel)]="newIndividual.fullName"
                        name="newFullName"
                        placeholder="pl. Nagy Péter"
                        [disabled]="isSubmitting"
                        required>
                      <mat-icon matSuffix>person</mat-icon>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="half-width">
                      <mat-label>Cím</mat-label>
                      <input matInput
                        [(ngModel)]="newIndividual.address"
                        name="newAddress"
                        placeholder="pl. 1234 Budapest, Példa utca 12."
                        [disabled]="isSubmitting">
                      <mat-icon matSuffix>location_on</mat-icon>
                    </mat-form-field>
                  </div>
                  <div class="form-row">
                    <mat-form-field appearance="outline" class="third-width">
                      <mat-label>Születési dátum</mat-label>
                      <input matInput
                        [(ngModel)]="newIndividualBirthDateString"
                        (ngModelChange)="onNewIndividualBirthDateStringChange()"
                        name="newBirthDate"
                        placeholder="yyyy.mm.dd"
                        pattern="[0-9]{4}\.[0-9]{2}\.[0-9]{2}"
                        title="Kérem a dátumot yyyy.mm.dd formátumban adja meg"
                        [class.error-field]="!isValidBirthDateFormat(newIndividualBirthDateString)"
                        required
                        [disabled]="isSubmitting">
                      <mat-icon matSuffix>event</mat-icon>
                      @if (isValidBirthDateFormat(newIndividualBirthDateString)) {
                        <mat-hint>yyyy.mm.dd</mat-hint>
                      }
                      @if (!isValidBirthDateFormat(newIndividualBirthDateString)) {
                        <mat-error>
                          @if (!newIndividualBirthDateString || newIndividualBirthDateString.trim() === '') {
                            <span>Születési dátum kötelező</span>
                          }
                          @if (newIndividualBirthDateString && newIndividualBirthDateString.trim() !== '' && !isValidBirthDateFormat(newIndividualBirthDateString)) {
                            <span>Érvénytelen formátum</span>
                          }
                        </mat-error>
                      }
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="third-width">
                      <mat-label>Adószám</mat-label>
                      <input matInput
                        [(ngModel)]="newIndividual.taxNumber"
                        name="newTaxNumber"
                        placeholder="12345678-1-23"
                        [disabled]="isSubmitting">
                      <mat-icon matSuffix>receipt</mat-icon>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="third-width">
                      <mat-label>Születési hely</mat-label>
                      <input matInput
                        [(ngModel)]="newIndividual.birthPlace"
                        name="newBirthPlace"
                        placeholder="Budapest"
                        [disabled]="isSubmitting">
                      <mat-icon matSuffix>place</mat-icon>
                    </mat-form-field>
                  </div>
                  <div class="form-row">
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Anyja neve</mat-label>
                      <input matInput
                        [(ngModel)]="newIndividual.motherName"
                        name="newMotherName"
                        placeholder="Kiss Mária"
                        [disabled]="isSubmitting">
                      <mat-icon matSuffix>woman</mat-icon>
                    </mat-form-field>
                  </div>
                  <!-- Személy hozzáadása gombok -->
                  <div class="add-individual-actions">
                    <button mat-button
                      (click)="cancelAddIndividual()"
                      [disabled]="isSubmitting">
                      <mat-icon>close</mat-icon>
                      Mégse
                    </button>
                    <button mat-raised-button
                      color="primary"
                      (click)="addIndividualToCompany()"
                      [disabled]="isSubmitting || !isNewIndividualValid()">
                      <mat-icon>add</mat-icon>
                      Hozzáadás
                    </button>
                  </div>
                </div>
              }
              <!-- Üres állapot üzenet -->
              @if (companyData.individuals.length === 0 && !showIndividualForm) {
                <div class="empty-individuals">
                  <p class="empty-message">
                    <mat-icon>info</mat-icon>
                    Még nincsenek hozzáadott személyek. Kattintson a "Személy hozzáadása" gombra új személy felviteléhez.
                  </p>
                </div>
              }
            </mat-card-content>
          </mat-card>
        }
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <!-- Mégse gomb -->
    <button mat-button (click)="onCancel()" [disabled]="isSubmitting">
      Mégse
    </button>

    <!-- Mentés gomb -->
    <button mat-raised-button
      color="primary"
      (click)="onSave()"
      [disabled]="isSubmitting || !canSave">
      @if (isSubmitting) {
        <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
      }
      @if (!isSubmitting) {
        <mat-icon>save</mat-icon>
      }
      Mentés
    </button>
  </mat-dialog-actions>
</div>